<template>
  <div class="header">
    <!--Preloader-->
    <div id="preloader">
        <div id="loader" class="loader">
            <div class="loader-container">
                <div class="loader-icon"><img src="assets/img/logokonsel.png" alt="Preloader" /></div>
            </div>
        </div>
    </div>
    <!--Preloader-end -->
    <!-- Scroll-top -->
    <button class="scroll__top scroll-to-target" data-target="html" @click="scrollToTop">
        <i class="fas fa-angle-up"></i>
    </button>
    <!-- Scroll-top-end-->
    <!-- header-area -->
    <header class="tg-header__style-five">
        <div class="tg-header__top">
            <div class="container custom-container">
                <div class="row">
                    <div class="col-lg-6">
                        <ul class="tg-header__top-info left-side list-wrap">
                            <li><i class="flaticon-phone-call"></i><a href="tel:082148094847">+62 821 4809 4847</a></li>
                            <li><i class="flaticon-pin"></i>Konawe Selatan, Sulawesi Tenggara 93393</li>
                        </ul>
                    </div>
                    <div class="col-lg-6">
                        <ul class="tg-header__top-right list-wrap">
                            <li><i class="flaticon-envelope"></i><a href="mailto:diskominfo@konaweselatankab.go.id">diskominfo@konaweselatankab.go.id</a></li>
                            <li><i class="flaticon-time"></i>Senin-Jumat: 08:00 - 16:00 WITA</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div id="sticky-header" class="tg-header__area tg-header__area-five">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="tgmenu__wrap">
                            <nav class="tgmenu__nav">
                                <div class="logo">
                                    <router-link to="/"><img src="assets/img/logo/diskominfo.png" alt="Logo" /></router-link>
                                </div>
                                <div class="tgmenu__navbar-wrap tgmenu__main-menu d-none d-lg-flex">
                                    <ul class="navigation">
                                      <li class="active"><router-link to="/">Beranda</router-link></li>
                                      <li class="menu-item-has-children">
                                        <a href="javascript:void(0)">Profil</a>
                                        <ul class="sub-menu">
                                          <li><router-link to="/profil">Profil Dinas</router-link></li>
                                          <li><router-link to="/tupoksi">Tugas Pokok & Fungsi</router-link></li>
                                          <li><router-link to="/visi">Visi & Misi</router-link></li>
                                          <li><router-link to="/struktur">Struktur Organisasi</router-link></li>
                                          <li><router-link to="/pejabat">Profil Pejabat Struktural</router-link></li>
                                        </ul>
                                      </li>
                                      <li class="menu-item-has-children">
                                        <a href="javascript:void(0)">Bidang</a>
                                        <ul class="sub-menu">
                                          <li><router-link to="/sekretariat">Sekretariat</router-link></li>
                                          <li><router-link to="/ikp">Bidang IKP</router-link></li>
                                          <li><router-link to="/tik">Bidang TIK</router-link></li>
                                          <li><router-link to="/persandian">Bidang Persandian</router-link></li>
                                          <li><router-link to="/datacenter">Bidang Data Center</router-link></li>
                                        </ul>
                                      </li>
                                      <li class="menu-item-has-children">
                                        <a href="javascript:void(0)">Informasi</a>
                                        <ul class="sub-menu">
                                          <li><router-link to="/berita">Berita</router-link></li>
                                          <li><a href="https://konaweselatankab.go.id/agenda_pengumuman/pengumuman/list" target="_blank">Pengumuman</a></li>
                                          <li><router-link to="/infografis">Infografis</router-link></li>
                                          <li><a href="http://ppid.konaweselatankab.go.id" target="_blank">PPID</a></li>
                                        </ul>
                                      </li>
                                      <li><a href="https://dashboard-superapp.konaweselatankab.go.id/" target="_blank">Layanan</a></li>
                                      <li class="menu-item-has-children">
                                        <a href="javascript:void(0)">Dokumen</a>
                                        <ul class="sub-menu">
                                          <li><router-link to="/dokumen">Data & Dokumen</router-link></li>
                                          <li><router-link to="/peraturan">Peraturan</router-link></li>
                                          <li><router-link to="/sop">SOP</router-link></li>
                                        </ul>
                                      </li>
                                      <li class="menu-item-has-children">
                                        <a href="javascript:void(0)">Laporan</a>
                                        <ul class="sub-menu">
                                          <li><router-link to="/dpa">DPA</router-link></li>
                                          <li><router-link to="/lakip">Lakip</router-link></li>
                                          <li><router-link to="/lppd">LPPD</router-link></li>
                                          <li><router-link to="/kinerja">Perjanjian Kinerja</router-link></li>
                                          <li><router-link to="/pmprb">PMPRB</router-link></li>
                                          <li><router-link to="/renstra">Renstra</router-link></li>
                                          <li><router-link to="/rka">RKA</router-link></li>
                                          <li><router-link to="/renja">Renja</router-link></li>
                                          <li><router-link to="/spbe">Peta SPBE</router-link></li>
                                        </ul>
                                      </li>
                                      <li class="menu-item-has-children">
                                        <a href="javascript:void(0)">Galeri</a>
                                        <ul class="sub-menu">
                                          <li><router-link to="/foto">Foto</router-link></li>
                                          <li><router-link to="/video">Video</router-link></li>
                                        </ul>
                                      </li>
                                      <li><router-link to="/kontak">Kontak</router-link></li>
                                    </ul>
                                </div>
                                <div class="tgmenu__action tgmenu__action-five d-none d-md-block">
                                    <ul class="list-wrap">
                                        <li class="header-btn">
                                            <div class="dark-light-switcher d-flex justify-content-center align-items-center rounded-3">
                                                <i class="theme-icon fas fa-sun"></i>
                                                <i class="theme-icon fas fa-moon"></i>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="mobile-nav-toggler mobile-nav-toggler-two" @click="openMobileMenu">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none">
                                        <path d="M0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2C4 3.10457 3.10457 4 2 4C0.895431 4 0 3.10457 0 2Z" fill="currentcolor" />
                                        <path d="M0 9C0 7.89543 0.895431 7 2 7C3.10457 7 4 7.89543 4 9C4 10.1046 3.10457 11 2 11C0.895431 11 0 10.1046 0 9Z" fill="currentcolor" />
                                        <path d="M0 16C0 14.8954 0.895431 14 2 14C3.10457 14 4 14.8954 4 16C4 17.1046 3.10457 18 2 18C0.895431 18 0 17.1046 0 16Z" fill="currentcolor" />
                                        <path d="M7 2C7 0.895431 7.89543 0 9 0C10.1046 0 11 0.895431 11 2C11 3.10457 10.1046 4 9 4C7.89543 4 7 3.10457 7 2Z" fill="currentcolor" />
                                        <path d="M7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9Z" fill="currentcolor" />
                                        <path d="M7 16C7 14.8954 7.89543 14 9 14C10.1046 14 11 14.8954 11 16C11 17.1046 10.1046 18 9 18C7.89543 18 7 17.1046 7 16Z" fill="currentcolor" />
                                        <path d="M14 2C14 0.895431 14.8954 0 16 0C17.1046 0 18 0.895431 18 2C18 3.10457 17.1046 4 16 4C14.8954 4 14 3.10457 14 2Z" fill="currentcolor" />
                                        <path d="M14 9C14 7.89543 14.8954 7 16 7C17.1046 7 18 7.89543 18 9C18 10.1046 17.1046 11 16 11C14.8954 11 14 10.1046 14 9Z" fill="currentcolor" />
                                        <path d="M14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16Z" fill="currentcolor" />
                                    </svg>
                                </div>
                            </nav>
                        </div>
                        <!-- Mobile Menu -->
                        <div class="tgmobile__menu" :class="{ 'visible': isMobileMenuVisible }">
                            <div class="tgmobile__menu-box">
                            <div class="close-btn" @click="closeMobileMenu">
                                <i class="fas fa-times"></i>
                            </div>
                            
                            <div class="nav-logo">
                                <router-link to="/">
                                <img src="assets/img/logo/diskominfo.png" alt="Logo" />
                                </router-link>
                            </div>

                            <div class="tgmobile__menu-outer">
                                <ul class="navigation">
                                <template v-for="(item, index) in menuData" :key="index">
                                    <li :class="{
                                    'active': $route.path === item.path,
                                    'menu-item-has-children': item.children,
                                    'open': item.isOpen
                                    }">
                                    <router-link 
                                      v-if="item.path && !item.path.startsWith('http')" 
                                      :to="item.path" 
                                      @click="closeMobileMenu">
                                      {{ item.title }}
                                    </router-link>
                                    <a 
                                      v-else-if="item.path && item.path.startsWith('http')" 
                                      :href="item.path" 
                                      target="_blank" 
                                      rel="noopener">
                                      {{ item.title }}
                                    </a>
                                    <a 
                                      v-else 
                                      href="javascript:void(0)" 
                                      @click.prevent="toggleSubmenu(index)">
                                      {{ item.title }}
                                    </a>
                                    <!-- <router-link v-if="item.path" :to="item.path" @click="closeMobileMenu">{{ item.title }}</router-link>
                                    <a v-else-if="item.path.startsWith('http')" :href="item.path">{{ item.title }}</a>
                                    <a v-else href="javascript:void(0)" @click.prevent="toggleSubmenu(index)">{{ item.title }}</a> -->

                                    
                                    <div v-if="item.children" class="dropdown-btn" @click.stop="toggleSubmenu(index)">
                                        <span class="plus-line" :class="{ 'open': item.isOpen }"></span>
                                    </div>
                                    
                                    <transition name="slide">
                                        <ul v-if="item.children && item.isOpen" class="sub-menu">
                                        <li v-for="(child, childIndex) in item.children" :key="childIndex">
                                            <a v-if="child.path.startsWith('http')" :href="child.path" target="_blank" >{{ child.title }}</a>
                                            <router-link v-else :to="child.path" @click="closeMobileMenu">{{ child.title }}</router-link>
                                        </li>
                                        </ul>
                                    </transition>
                                    </li>
                                </template>
                                </ul>
                            </div>
                            <div class="tgmobile__menu-bottom">
                                <div class="contact-info">
                                <ul class="list-wrap">
                                    <li><a href="mailto:diskominfo@konaweselatankab.go.id">diskominfo@konaweselatankab.go.id</a></li>
                                    <li><a href="tel:01234567890">+62 1234 5678 90</a></li>
                                </ul>
                                </div>
                                <div class="social-links">
                                <ul class="list-wrap">
                                    <li><a href="javascript:void(0)"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="javascript:void(0)"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="javascript:void(0)"><i class="fab fa-instagram"></i></a></li>
                                </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="tgmobile__menu-backdrop" :class="{ 'visible': isMobileMenuVisible }" @click="closeMobileMenu"></div>
                        <!-- End Mobile Menu -->
                    </div>
                </div>
            </div>
        </div>
    </header>
    <!-- header-area-end -->
  </div>
</template>

<script>
export default {
  name: 'Header',
   data() {
    return {
      isMobileMenuVisible: false,
      menuData: [
        { title: 'Beranda', path: '/' },
        {
          title: 'Profil',
          isOpen: false,
          children: [
            { title: 'Profil Dinas', path: '/profil' },
            { title: 'Tugas Pokok & Fungsi', path: '/tupoksi' },
            { title: 'Visi Misi', path: '/visi' },
            { title: 'Struktur Organisasi', path: '/struktur' },
            { title: 'Profil Pejabat Struktural', path: '/pejabat' },
          ]
        },
        {
          title: 'Bidang',
          isOpen: false,
          children: [
            { title: 'Sekretariat', path: '/sekretariat' },
            { title: 'Produksi Prasarana & Sarana', path: '/sarana' },
            { title: 'Penyuluhan', path: '/penyuluhan' },
            { title: 'Kesehatan Hewan, Kesmavet, Pengolahan & Pemasaran', path: '/pengolahan' },
            { title: 'Perbibitan & Produksi', path: '/perbibitan' },
          ]
        },
        {
          title: 'Informasi',
          isOpen: false,
          children: [
            { title: 'Berita', path: '/berita' },
            { title: 'Pengumuman', path: 'https://konaweselatankab.go.id/agenda_pengumuman/pengumuman/list' },
            { title: 'Infografis', path: '/infografis' },
            { title: 'PPID', path: 'http://ppid.konaweselatankab.go.id' },
          ]
        },
        { title: 'Layanan', path: 'https://dashboard-superapp.konaweselatankab.go.id/' },
        {
          title: 'Dokumen',
          isOpen: false,
          children: [
            { title: 'Peraturan', path: '/peraturan' },
            { title: 'SOP', path: '/sop' },
          ]
        },
        {
          title: 'Laporan',
          isOpen: false,
          children: [
            { title: 'DPA', path: '/dpa' },
            { title: 'Lakip', path: '/lakip' },
            { title: 'LPPD', path: '/lppd' },
            { title: 'Perjanjian Kinerja', path: '/kinerja' },
            { title: 'PMPRB', path: '/pmprb' },
            { title: 'Renstra', path: '/renstra' },
            { title: 'RKA', path: '/rka' },
            { title: 'Renja', path: '/renja' },
            { title: 'Peta SPBE', path: '/spbe' },
          ]
        },
        {
          title: 'Galeri',
          isOpen: false,
          children: [
            { title: 'Foto', path: '/foto' },
            { title: 'Video', path: '/video' }
          ]
        },
        { title: 'Kontak', path: '/kontak' },
      ].map(item => {
        if (item.children) {
          return { ...item, isOpen: false }
        }
        return item
      })
    }
  },
  watch: {
    $route() {
      this.closeMobileMenu();
    }
  },
  methods: {
    openMobileMenu() {
      this.isMobileMenuVisible = true
      document.body.classList.add('mobile-menu-visible')
    },
    closeMobileMenu() {
      this.isMobileMenuVisible = false;
      document.body.classList.remove('mobile-menu-visible');
      this.menuData.forEach(item => {
        if (item.isOpen) item.isOpen = false;
      });
    },
    toggleSubmenu(index) {
      this.menuData.forEach((item, i) => {
        if (i !== index && item.isOpen) {
          item.isOpen = false
        }
      })
      this.menuData[index].isOpen = !this.menuData[index].isOpen
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    async push_link(id) {
      await this.$router.push('/layanan?id=' + id);
      window.location.reload();
    }
  },
  mounted() {
    this.menuData = this.menuData.map(item => ({
      ...item,
      isOpen: false
    }))
    
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isMobileMenuVisible) {
        this.closeMobileMenu()
      }
    })
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.closeMobileMenu)
  }
}
</script>

<style>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.slide-enter-to,
.slide-leave-from {
  max-height: 500px;
  opacity: 1;
  padding-top: 10px;
  padding-bottom: 10px;
}

.dropdown-btn .plus-line {
  position: relative;
  display: inline-block;
  width: 12px;
  height: 12px;
  transition: transform 0.3s ease;
}

.dropdown-btn .plus-line:before,
.dropdown-btn .plus-line:after {
  content: '';
  position: absolute;
  background-color: currentColor;
  transition: all 0.3s ease;
}

.dropdown-btn .plus-line:before {
  width: 100%;
  height: 2px;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.dropdown-btn .plus-line:after {
  width: 2px;
  height: 100%;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}

.dropdown-btn .plus-line.open:after {
  transform: translateX(-50%) rotate(90deg);
  opacity: 0;
}

.sub-menu {
  display: block !important;
  padding-left: 15px;
  will-change: max-height, opacity, padding;
}

.tgmobile__menu-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  visibility: hidden;
}

.tgmobile__menu-wrapper.visible {
  visibility: visible;
}

.tgmobile__menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  height: 100vh;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  z-index: 10000;
}

.tgmobile__menu-wrapper.visible .tgmobile__menu {
  transform: translateX(0);
}

.tgmobile__menu-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.tgmobile__menu-wrapper.visible .tgmobile__menu-backdrop {
  opacity: 1;
  pointer-events: all;
}

body.mobile-menu-visible {
  overflow: hidden;
}

</style>